import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Search from './pages/Search'
import Home from './pages/Home'


function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/home" index element={<Home />} />
          <Route path="/search/:searchTerm" index element={<Search />} />
        </Routes>
      </Router>

      {/* <Header />
      <div className="app__page">
        <Sidebar />
        <RecommendedVideos />
      </div>*/}
    </div>
  )
}

export default App
